import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { isAxiosError } from 'axios';

import { experimentManagementApi } from '@/entities/experiment/api/experimentManagementApi';
import type { UpdateExperimentRequest } from '@/entities/experiment/domain/experimentManagementTypes';

import { EXPERIMENT_MANAGEMENT_QUERY_KEY } from './useExperimentManagementList';
import { PROJECTS_EXPERIMENTS_QUERY_KEY } from './useProjectsExperiments';

export const useUpdateExperimentManagement = (experimentId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateExperimentRequest) => experimentManagementApi.update(experimentId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EXPERIMENT_MANAGEMENT_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROJECTS_EXPERIMENTS_QUERY_KEY] });
      message.success('실험이 수정되었습니다');
    },
    onError: (error: Error) => {
      const errorMessage =
        isAxiosError(error) && error.response?.data?.message ? error.response.data.message : '실험 수정에 실패했습니다';

      message.error(errorMessage);
    },
  });
};
